import useSWR, { SWRConfiguration, mutate } from 'swr';
import fetchDataService from '../services/fetchDataService';
import { generateFrontKeys} from '../services/securityService';
import { useCallback } from 'react';

/**
 * Verifica y carga la sesión en el cliente
 */
function useLoadBase(tokenData:any,baseData:any){
  const config = {
    revalidateIfStale: true,
    revalidateOnFocus: true,
    revalidateOnReconnect: false,
    refreshWhenOffline: false,
    refreshWhenHidden: false,
  }
  
  const fetcher = () => fetchDataService.post('/security/base/load-base',tokenData.key,{...baseData,csrfToken:tokenData?.token.uid})  
  const {data,error} = useSWR(()=>(tokenData.key && baseData.fingerprint) ? ['/security/base/load-base',tokenData.token.uid]:null,fetcher,config)

  return {
    data,
    error
  }
}

/**
 * Carga los datos iniciales de la aplicación
 */
function useIndex(tokenData:any,indexData:any){
  const config:SWRConfiguration = {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    refreshWhenOffline: false,
    refreshWhenHidden: false,
  }
  const fetcher = () => fetchDataService.post('/security/base/index',tokenData.key,{...indexData,csrfToken:tokenData?.token.uid})  
  const {data,error} = useSWR(()=> tokenData.key  ? ['/security/base/index',tokenData.token.uid]: null,fetcher,config)

  return {
    data,
    error
  }
}

/**
 * Genera los token para validar peticiones
 */
function useToken(typeToken:any,session:any,serverKey:any){
  const frontKeyFetcher = async () => {
    await generateFrontKeys()
    const key = localStorage.getItem('frontKey')
    return {key}
  }
  const {data:frontKey} = useSWR('generatefrontkeys',frontKeyFetcher)

  const url = typeToken.toLowerCase().includes("auth") ? '/security/auth/create-authsession' : '/security/auth/create-session'
  const serverKeyFetcher = () => fetchDataService.post('/public/key',null,{})
  const tokenFetcher = (args:any) => fetchDataService.post(url,args[1],{
      typeToken,
      timeToken: 30,
      session
    }) 
  const config:SWRConfiguration = {
    revalidateIfStale: true,
    dedupingInterval: 30000,
    revalidateOnFocus: true,
    revalidateOnReconnect: false,
    refreshWhenOffline: false,
    refreshWhenHidden: false,
  }
  const callToServerKey = frontKey && !serverKey
  const {data:keyData } = useSWR(()=> callToServerKey ? '/public/key':null,serverKeyFetcher,config)
  const dataToInitServer = keyData ? keyData.data : serverKey
  const {data:tokenData, mutate: mutateTokenData } = useSWR(()=>dataToInitServer ? [url+window.location.pathname,dataToInitServer]:null,
    tokenFetcher,config
  )
  const redirect = btoa(window.location.href)
  if(tokenData?.status === 401){
    window.location.href = tokenData.redirect + "?redirect=" + redirect
  }
  
  const resetState = useCallback(() => {
    mutateTokenData(undefined, { revalidate: true });
  }, [mutateTokenData]);

  return {
    tokenData,
    resetState
  }
}
const Auth = {
  useLoadBase,
  useIndex,
  useToken
}
export default Auth
